import { SAVE_RECORDINGS, CLEAR_RECORDINGS } from '../types/recordings';

export const saveRecordings = data => ({ type: SAVE_RECORDINGS, payload: data });
export const clearRecordings = () => ({ type: CLEAR_RECORDINGS });
